"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVoucherExternalUpload = void 0;
var react_redux_1 = require("react-redux");
var file_1 = require("remota-client/hook/file");
// ================================================================
// File Upload
var useVoucherExternalUpload = function (jobInputId, jobId) {
    var state = (0, react_redux_1.useSelector)(function (state) { return state.loading; });
    return (0, file_1.useVoucherUploadBase)(state, jobInputId, jobId, true);
};
exports.useVoucherExternalUpload = useVoucherExternalUpload;
